import { Injectable } from '@angular/core';

import { merge, BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
   providedIn: 'root'
})
export class AppContainerService {
   windowHeight$ = new BehaviorSubject<number>( window.innerHeight );

   menuHeight$ = new BehaviorSubject<number>( 0 );
   footerHeight$ = new BehaviorSubject<number>( 0 );
   footerHeightObservable$ = this.footerHeight$.pipe( debounceTime( 1 ));

   viewportHeight$ = new BehaviorSubject<number>( window.innerHeight );

   constructor() {
      fromEvent( window, 'resize' ).subscribe( _ =>
         this.windowHeight$.next( window.innerHeight ));

      merge(
         this.windowHeight$,
         this.menuHeight$,
         this.footerHeight$,
      ).pipe(
         debounceTime( 10 ),
      ).subscribe( _ => {
         this.viewportHeight$.next(
            Math.max( this.windowHeight$.getValue(), document.body.clientHeight ) -
               ( this.menuHeight$.getValue() + this.footerHeight$.getValue() )
         );
      });
   }
}
